import React from "react";
import {
  Select,
  Label,
  Input,
  Text,
  makeStyles,
} from "@fluentui/react-components";
import { CoverageComponentProps } from "./types";

const useStyles = makeStyles({
  rightAlignedInput: {
    "& input": {
      textAlign: "right",
    },
  },
});

const WindshieldCoverage: React.FC<CoverageComponentProps<"windshield">> = ({
  config,
  onConfigChange,
  t,
  classes,
}) => {
  const styles = useStyles();

  // Format number with thousands separators
  const formatNumber = (num: number | undefined): string => {
    if (num === undefined || num === null || num === 0) return "";
    return num.toLocaleString("cs-CZ");
  };

  // Parse formatted string back to number
  const parseFormattedNumber = (value: string): number => {
    const cleaned = value.replace(/\s/g, "").replace(/,/g, "");
    return parseInt(cleaned) || 0;
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "16px",
          alignItems: "flex-end",
          justifyContent: "flex-start",
          marginBottom: "16px",
        }}
      >
        <div
          className={classes.fieldGroup}
          style={{ flex: "0 0 calc(33.33% - 8px)" }}
        >
          <Label
            htmlFor="windshieldType"
            required
            style={{ marginBottom: "4px" }}
          >
            Type of windshield insurance
          </Label>
          <Select
            id="windshieldType"
            value={config.type || "front"}
            onChange={(_, data) =>
              onConfigChange({
                type: data.value,
              })
            }
          >
            <option value="front">Front Windshield</option>
            <option value="all">All windows</option>
          </Select>
        </div>

        <div
          className={classes.fieldGroup}
          style={{ flex: "0 0 calc(33.33% - 8px)" }}
        >
          <Label
            htmlFor="insuranceLimit"
            required
            style={{ marginBottom: "4px" }}
          >
            Insurance limit
          </Label>
          <Input
            id="insuranceLimit"
            className={styles.rightAlignedInput}
            value={formatNumber(config.insuranceLimit)}
            onChange={(_, data) => {
              const numValue = parseFormattedNumber(data.value);
              // Limit the value between 4,000 and 500,000
              const limitedValue = Math.min(
                500000,
                Math.max(4000, numValue || 4000)
              );
              onConfigChange({
                insuranceLimit: limitedValue,
              });
            }}
            contentAfter={<Text>Kč</Text>}
            placeholder="4,000 - 500,000"
          />
        </div>

        <div style={{ flex: "0 0 calc(33.33% - 8px)" }}></div>
      </div>
    </>
  );
};

export default WindshieldCoverage;
